<template>
    <div class="main-data-progress-bar-preview" v-loading="loading">
        <div class="bar-box" v-if="dataProgressBarConfig.progressBarType==1">
            <div class="progress-bar-item" v-for="(item,index) in progressData" :key="index">
                <div class="progress-bar-item-tit">
                    {{item.key}}
                </div>
                <div class="progress-bar-item-bar">
                    <el-progress :text-inside="true" :stroke-width="16" :percentage="parseValue(item.percentage)"></el-progress>
                </div>
            </div>
        </div>
        <div class="ring-box"  v-if="dataProgressBarConfig.progressBarType==2">
            <div class="progress-bar-item" v-for="(item,index) in progressData" :key="index">
                <div class="progress-bar-item-tit">
                    {{item.key}}
                </div>
                <div class="progress-bar-item-bar">
                   <el-progress type="circle" :percentage="parseValue(item.percentage)"></el-progress>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { isEmpty } from 'lodash';
import {getDataProgressBarList} from '@/data-model';
export default{
    components: {

    },
    props: {
        dataProgressBarConfig: {
            type: Object
        }
    },
    data () {
        return {
            progressData: [],
            loading: false
        };
    },
    created () {
        if (!isEmpty(this.dataProgressBarConfig)) {
            this.getDataProgressBarList();
        }
    },
    methods: {
        async getDataProgressBarList () {
            this.loading = true;
            let res = await getDataProgressBarList(this.dataProgressBarConfig);
            this.progressData = res.progressData;
            this.loading = false;
        },
        parseValue (o) {
            if (Number(o) > 100) {
                return 100;
            } else {
                return Number(o);
            }
        }
    }
};
</script>

<style lang="less">
    .main-data-progress-bar-preview{
        .bar-box{
            .progress-bar-item{
                cursor: pointer;
                width: 96%;
                margin-left: 2%;
                margin-top: 8px;
                .progress-bar-item-tit{
                    height: 30px;
                    line-height: 30px;
                }
            }
        }
        .ring-box{
           display: flex;
           flex-flow: row wrap;
           .progress-bar-item{
               width: 200px;
               cursor: pointer;
              .progress-bar-item-tit{
                 width: 100%;
                 text-align: center;
                 margin-top: 30px;
              }
              .progress-bar-item-bar{
                  width: 100%;
                  margin-top: 10px;
                  text-align: center;
              }
           }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/DataWarehousing/DataProgressBarPreview.vue